import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { motion, useScroll, useSpring } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { Cursor } from "./components/Cursor";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { Packages } from "./components/Packages";
import { CarePlans } from "./components/CarePlans";
import { QuoteCalculator } from "./components/QuoteCalculator";
import { Benefits } from "./components/Benefits";
import { Process } from "./components/Process";
import { Portfolio } from "./components/Portfolio";
import { DemoSection } from "./components/DemoSection";
import { About } from "./components/About";
import { Faq } from "./components/Faq";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { AiChat } from "./components/AiChat";
import LegalPage from "./pages/LegalPage";
import Admin from "./pages/Admin";
import Pay from "./pages/Pay";
import { PaySuccess, PayCancel } from "./pages/PayResult";

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 30, mass: 0.4 });
  return (
    <motion.div
      data-testid="scroll-progress"
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[3px] z-[100] origin-left bg-gradient-to-r from-[#0055FF] to-cyan-400"
      style={{ scaleX }}
    />
  );
};

const Home = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 0.9, anchors: { offset: -88 } });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <>
      <Cursor />
      <ScrollProgress />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Packages />
        <CarePlans />
        <QuoteCalculator />
        <Benefits />
        <Process />
        <Portfolio />
        <DemoSection />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
      <AiChat />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/terms" element={<LegalPage kind="terms" />} />
          <Route path="/cookies" element={<LegalPage kind="cookies" />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/pay" element={<Pay />} />
          <Route path="/pay/success" element={<PaySuccess />} />
          <Route path="/pay/cancel" element={<PayCancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-center" toastOptions={{ style: { background: "#ffffff", border: "1px solid #e2e8f0", color: "#0f172a", boxShadow: "0 8px 30px rgb(0,0,0,0.08)" } }} />
    </div>
  );
}

export default App;
